export default __webpack_public_path__ + "static/media/Bilal_Baig_Resume.06335ce1.pdf";